import controller from './login.controller';
import template from './login.view.html';

let LoginComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default LoginComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/login/login.component.js
 **/